import React from 'react';
import { useEffect, useReducer, useState } from "react";
import { CustomizedMetaCard } from "../../../component/zComponents/CustomizedMetaCard/CustomizedMetaCard";
import { TabsComponent } from "./tabs-component/TabsComponent";
import { IDetailViewInitPayload, IDetailViewLayoutResponse, TDetailViewComponentType } from "./DetailedView.d";
import { fetchDetailData, fetchDetailLayout } from "../orderDataProvider";
import { IColumnObject, IMetaCardConfig } from "../../../component/zComponents/CustomizedMetaCard/CustomizedMetaCard.d";
import { IDetailedViewProps, TDetailViewPayload, IDetailViewState, IDetailViewActionProps, DetailViewAction } from "./DetailedView.d";
import { Loader } from "../../../component/utility/Loader/Loader";
import ZFIcon from "../../../component/ui-component/ZFIcon/ZFIcon";
import { ISelectedFilter, ITabsComponentFilter, ITabsViewConfig } from "./tabs-component/TabsComponent.d";
import { v4 as uuidv4 } from "uuid";
import { format } from "date-fns";
import { cloneDeep, get, chunk } from "lodash";
import { TFilterDropDownData } from "../../../fixtures/data-fixtures/ComponentConfigFixtures";
import ErrorBoundary from "../../../component/utility/ErrorBoundary/ErrorBoundary";
import { ErrorFallback } from "../../../component/utility/ErrorBoundary/ErrorFallback";

const detailedViewReducer = (state: IDetailViewState, actionProps: IDetailViewActionProps): IDetailViewState => {
	const { type } = actionProps;
	const payload = actionProps.payload as TDetailViewPayload;

	switch(type) {
		case DetailViewAction.INIT_STATE:
			return {...(payload as IDetailViewInitPayload).state};

		default: return { ...state };
	}
}

export const DetailedView = (props: IDetailedViewProps) => {

    const initState = { 
		styles: [
			{
				displayName: 'Style 1',
				key: 'style_1',
				components: [
					{
                        id: uuidv4(),
						type: 'META_CARD',
						config: { tabs: [] },
						data: {},
                        filters: []
					}, 
					{
                        id: uuidv4(),
						type: 'XY_CHART_TABS',
						config: {},
						data: {},
						filters: []
					},
					{
                        id: uuidv4(),
						type: 'XY_CHART_TABS',
						config: {},
						data: {},
                        filters: []
					},
					{
                        id: uuidv4(),
						type: 'XY_CHART_TABS',
						config: {},
						data: {},
                        filters: []
					}
				]
			}
		],
		activeStyleIndex: 0,
        lastSyncTime: new Date()
	} as IDetailViewState;

	const [detailedViewState, dispatch] = useReducer(
		detailedViewReducer,
		initState
	);

	const [loaderState, setLoaderState] = useState(true);

	useEffect(() => {
        const setConfigAndData = async () =>  {
            try {
                const layout = await fetchDetailLayout();
                const transformedState = transformLayoutToState(layout);
    
                let newState = transformedState;

                try {
                    newState = await dataCall(props.orderShippableId, transformedState);
                } catch {
                    console.error('Failed to fetch order detail data');
                } finally {
                    dispatch({ type: DetailViewAction.INIT_STATE, payload: { state: {...newState, lastSyncTime: new Date() } }});
                };
            } catch (e) {
                console.error('Failed to assign detail view config', e);
            } finally {
                setLoaderState(false);
            }
        }

        setConfigAndData();
	},  []);

    const syncComponents = (state: IDetailViewState) => {
        setLoaderState(true);
        dataCall(props.orderShippableId, state).then((st) => {
            dispatch({ type: DetailViewAction.INIT_STATE, payload: { state: {...st, lastSyncTime: new Date() } }});
        }).finally(() => setLoaderState(false));
    }

	return (
		<div>
			{
				(loaderState) && <div className="data-loader"><Loader size="L_LARGE"></Loader></div>
			}
			{
				(!loaderState) && (
					<>
						<div className="hdr-border-b zf-margin-b-xxl-m">
							<span className="zf-text-font-size-xl zf-text-color-black">Orders</span>
							<div className="align-item zf-margin-t-m zf-margin-b-xxl-s">
								<span className="zf-text-font-size-xs zf-text-color-black-80">
									Last updated on {format(detailedViewState.lastSyncTime, "MMM dd h:mm a")}
								</span>
								<div onClick={() => syncComponents(detailedViewState)} className="btn-hover-pointer">
									<ZFIcon
										iconName="sync"
										iconClasses={[
											"zf-icon-react--size-md zf-icon-react--bg-cover zf-margin-l-m",
										]}
									/>
								</div>
							</div>
						</div>

						<div className="zf-margin-b-xxl-m align-item align-item__h-center">
							<div onClick={props.onBackButton} className="zf-margin-r-xxl-m btn-hover-pointer">
								<ZFIcon
									iconName="arrow-fw"
									iconClasses={[
										"zf-icon-react--size-md zf-icon-react--bg-center zf-icon-react--bg-contain zf-icon-react--rotate-180 zf-margin-l-m",
									]}
								/>
							</div>
							<span className="zf-text-font-size-s zf-text-color-black-80 zf-text-font-weight-bold zf-margin-r-xxl-1">ORDER DETAILS</span>
							{/* { 
								detailedViewState.styles.map((style, i) => {
									return <span key={`style_${style.key}`} className="zf-text-color-black zf-text-font-size-s zf-text-font-weight-medium zf-padding-l-s zf-padding-r-s zf-padding-t-xs zf-padding-b-xs zf-margin-r-xxl-s zf-border-r-xl-l btn-hover-pointer" style={{'backgroundColor': (i === detailedViewState.activeStyleIndex) ? '#e0f3ff' : 'transparent'}}>{style.displayName}</span>
								})
							} */}
						</div>

						<div>
							{
								detailedViewState.styles[detailedViewState.activeStyleIndex].components.map((comp) => {
									return (
										<div key={`detail_card_${comp.id}`} className="react-component" style={{marginBottom: 20}}>
											{
												(comp.type === 'META_CARD') && (
                                                    <ErrorBoundary FallbackComponent={ErrorFallback}>
													    <CustomizedMetaCard config={comp.config as IMetaCardConfig} data={comp.data}/>
                                                    </ErrorBoundary>
												)
											}
											{
												(comp.type === 'XY_CHART_TABS') && (
                                                    <ErrorBoundary FallbackComponent={ErrorFallback}>
                                                        <TabsComponent config={comp.config as ITabsViewConfig} filters={comp.filters} data={comp.data}
                                                        onFilterChange={(selectedFilters) => fetchComponentData(selectedFilters, comp.id, props.orderShippableId)}
                                                        syncTime={detailedViewState.lastSyncTime}/>
                                                    </ErrorBoundary>
												)
											}
										</div>
									)
								})
							}
						</div>
					</>
				)
			}
		</div>
	);
};

const transformComponentConfig = (config: IMetaCardConfig | ITabsViewConfig, componentType: TDetailViewComponentType, date: Date) => {
    const clonedConfig = cloneDeep(config);

    switch (componentType) {
        case 'META_CARD':
            (clonedConfig as IMetaCardConfig).tabs.forEach((tab) => {
                tab["key"] = '';
                tab["value"] = '';

                const columns = [];

                tab.config.forEach((row) => columns.push(...row));

                if (columns.length > 5) {
                    const rows = chunk(columns, 5);
                    const lastRow = rows[rows.length - 1];
                    while (lastRow.length < 5) {
                        lastRow.push({ header: '' });
                    }
                    tab.config = cloneDeep(rows);
                }
            })
            
            break;

        case 'XY_CHART_TABS':
            (clonedConfig as ITabsViewConfig).tabs.forEach((tab) => {
                tab.subTabs.forEach((subTab) => {
                    subTab.header = format(date, "dd MMM yyyy")
                })
            })
            break;

        default: break;
    }

    return clonedConfig;
}

const transformLayoutToState = (layout: IDetailViewLayoutResponse): IDetailViewState => {
    const date = new Date();

    return {
        styles: [
            {
                displayName: '',
                key: '',
                components: layout.components.map((component) => {
                    return {
                        type: component.type,
                        id: component.id,
                        config: transformComponentConfig(component.config.option, component.type, date),
                        data: {},
                        filters: ((component.filterDTOS) ? component.filterDTOS.map((filter) => {
                            return {
                                key: filter.key,
                                multiSelection: filter.multiSelection,
                                displayValue: filter.displayValue,
                                selected: false,
                                config: {
                                    filters: [],
                                    selected: [],
                                    header: filter.displayValue,
                                    searchString: '',
                                    onFilterChange: () => {}
                                }
                            }
                        }) : []) as Array<ITabsComponentFilter>
                    }
                })
            }
        ],
        activeStyleIndex: 0,
        lastSyncTime: date
    }
}

const dataCall = async (orderShippableId: string, state: IDetailViewState) => {
    const clonedState = cloneDeep(state);
    const componentRequests = clonedState.styles[clonedState.activeStyleIndex].components.map((comp) => {
        return { componentId: comp.id, filters: [] };
    });

    try {
        const data = await fetchDetailData({ shippableId: orderShippableId, componentRequests });
        clonedState.styles[clonedState.activeStyleIndex].components.forEach((comp) => {
            const obj = data[comp.id] || {};
            comp.data = obj.componentData || {};
            comp.filters = comp.filters.map((filter: ITabsComponentFilter) => {
                const filterData = (obj.dataForFiltersDropdown || []).find((f) => f.key === filter.key);
                const filterValues: TFilterDropDownData[] = (filterData && Array.isArray(filterData.values)) ? filterData.values.map((_) => {
                    return { dimension: Math.random(), value: _ }
                }) : null;

                if (filterValues && filterValues.length > 0) {
                    if (comp.id === 'OrderColorSizeDistributionDetailsComponent') {
                        const firstFilter = filterValues[0];
                        return { ...filter, displayValue: firstFilter.value, config: { ...filter.config, filters: filterValues, selected: [firstFilter] } };
                    } else {
                        return { ...filter, config: { ...filter.config, filters: filterValues } };
                    }
                } else {
                    return filter;
                }
            });
        });
    } catch (e) {
        // clonedState.styles[clonedState.activeStyleIndex].components.forEach((comp) => {
        //     comp.data = {};
        // });
        console.error('Could not assign detail view data', e);
    } finally {
        return clonedState;
    }
}

const fetchComponentData = (selectedFilters: Array<ISelectedFilter>, componentId: string, orderShippableId: string) => {
    // Call respective component API and pass on the data.
    const componentRequests = [{ componentId, filters: selectedFilters }];
    return fetchDetailData({ shippableId: orderShippableId, componentRequests }).then((data) => {
        const obj = data[componentId] || {};
        return obj.componentData || {};
    }).catch(() => {});
}

